import { MDXRemote } from 'next-mdx-remote';

import DocLayout from 'components/layouts/DocLayout';
import MdTextStack from 'components/mdxComponents/PageTextStack/PageTextStack';
import { mdxComponents } from 'components/mdxComponents/docMdx';
import { MdxPageProps } from 'types/pages';

const MdxDocPage: React.FC<MdxPageProps> = ({ seo, mdxContent, repoUrl }) => (
  <DocLayout seo={seo} repoUrl={repoUrl}>
    <MdTextStack>
      <MDXRemote {...mdxContent} components={mdxComponents} />
    </MdTextStack>
  </DocLayout>
);

export default MdxDocPage;
